import type { ReactNode } from "react"

import { Logo } from "../../components"
import { Header } from "../header"
import { UserAccountForm } from "../user-account-form"
import { UserAccountFormHeader } from "../user-account-form-header"

const AgentWorkspaceHeaderSlot = ({ children }: { children?: ReactNode }) => (
  <Header kind="omni" statusSwitcher={children} />
)

export const AgentWorkspaceHeader = Object.assign(AgentWorkspaceHeaderSlot, {
  Logo,
  AccountSettings: UserAccountForm,
  AccountSettingsHeader: UserAccountFormHeader
})
